import ApiClientUser from './apiClientUser'
import { useAuthStore } from './authStore'

// Vytvoríme jedinú inštanciu ApiClientUser pre celú aplikáciu
const apiClientUser = new ApiClientUser()

// Pri prvom načítaní aplikácie nastavíme token z `authStore`
const auth = useAuthStore.getState().auth
apiClientUser.setAuthToken(auth?.token ?? null)

// Počúvame na zmeny v `authStore` a aktualizujeme `apiClientUser`
useAuthStore.subscribe((state) => {
  apiClientUser.setAuthToken(state.auth?.token ?? null)
})

/**
 * Hook to get the api instance (Nest /user doc — onboarding + auth + settings +
 * notifications + content + logs + dev, apiClientUser).
 * Synchronizuje token zo store pri každom renderi, čím sa vyhne race condition
 * keď hasAuthToken je už true, ale client ešte nemal token.
 */
export function useApiClientUser() {
  const auth = useAuthStore((state) => state.auth)
  // Sync token pred vrátením - zaručí, že client má token keď ho komponent použije
  apiClientUser.setAuthToken(auth?.token ?? null)
  return apiClientUser.apiInstance
}

// Singleton pre použitie mimo Reactu (napr. checkAuth v routeri).
export { apiClientUser }

/** Over platnosť session: lokálna expirácia + ping na `user/account/info`. */
export async function checkAuth(): Promise<boolean> {
  const auth = useAuthStore.getState().auth
  if (auth == null) return false

  if (auth.expiration <= Date.now()) {
    useAuthStore.getState().removeAuthToken()
    return false
  }

  try {
    await apiClientUser.apiInstance.user.accountInfoControllerGetInfo({
      secure: true,
    })
    return true
  } catch {
    return false
  }
}
